export const IdTypeOption = {
  ID_CARD: "ID_CARD",
  PASSPORT: "PASSPORT"
}

export const VisitorTypeOptions = ["Thai", "Foreigner"]